/* src/app/billing/payment-history/payment-receipt/payment-receipt.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.payment-receipt-dialog .deprecated-key-values {
  width: 100%;
}
.payment-receipt-dialog .deprecated-key-values .key-value {
  width: 100%;
}
@media print {
  .payment-receipt-dialog .deprecated-key-values .key-value {
    width: 25em;
  }
}
.payment-receipt-dialog .deprecated-key-values .key-value .value {
  white-space: pre-wrap;
  text-align: right;
}
@media screen and (min-width: 48rem) {
  .payment-receipt-dialog .deprecated-key-values .key-value .value {
    text-align: left;
  }
}
.print-button {
  margin-bottom: 2rem;
}
.visible-print {
  visibility: hidden !important;
  width: 0;
}
@media print {
  .dont-print {
    visibility: hidden !important;
  }
  .visible-print {
    visibility: visible !important;
    width: auto;
  }
}
.ups-dialog .mat-mdc-dialog-content {
  padding: 0 3em;
}
/*# sourceMappingURL=payment-receipt.component.css.map */
